import React from "react";
import { ACTIVITIES } from "../lib/siteData";
import { Gamepad2, ArrowUpRight } from "lucide-react";

export default function Activities() {
  return (
    <section
      id="activities"
      data-testid="activities-section"
      className="py-20 sm:py-28 bg-ivorySoft border-y border-ink-10 relative overflow-hidden"
      style={{ borderColor: "rgba(30,27,75,0.12)" }}
    >
      {/* Playful decorative shapes */}
      <div
        aria-hidden
        className="absolute top-10 right-10 h-24 w-24 rounded-full opacity-[0.12]"
        style={{ background: "#EC4899" }}
      />
      <div
        aria-hidden
        className="absolute bottom-16 left-12 h-16 w-16 opacity-[0.12]"
        style={{ background: "#10B981" }}
      />

      <div className="container-prose relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-7">
            <p className="overline flex items-center gap-2 text-saffron">
              <Gamepad2 size={14} />
              05 — Activities & Games
            </p>
            <h2 className="h2-display mt-4 text-4xl sm:text-6xl text-ink">
              Original classroom <span className="italic text-saffron">activities</span> &amp;{" "}
              <span className="italic text-magenta">games</span>.
            </h2>
          </div>
          <div className="lg:col-span-5 flex items-end">
            <p className="body-prose text-base sm:text-lg text-ink/75 max-w-md">
              Beyond frameworks, these are the tangible classroom tools — board games,
              kinesthetic activities, journals and systems — Karamjeet has built across two
              decades of practice.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-ink/15">
          {ACTIVITIES.map((a, i) => (
            <article
              key={a.code}
              data-testid={`activity-card-${a.code}`}
              className="group relative bg-ivory p-7 sm:p-8 hover:bg-ink hover:text-ivory transition-colors overflow-hidden"
            >
              <span
                aria-hidden
                className="absolute top-0 left-0 h-1 w-12 group-hover:w-full transition-all duration-500"
                style={{ background: a.accent }}
              />
              <div className="flex items-start justify-between gap-3">
                <span
                  className="text-sm tracking-widest text-ink/50 group-hover:text-ivory/60"
                  style={{ fontFamily: "Outfit, sans-serif" }}
                >
                  {a.code}
                </span>
                <ArrowUpRight
                  size={16}
                  className="text-ink/30 group-hover:text-saffron group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"
                />
              </div>

              <h3
                className="mt-4 text-2xl sm:text-3xl leading-tight"
                style={{ fontFamily: '"Cormorant Garamond", serif', fontWeight: 500 }}
              >
                {a.name}
              </h3>
              <p
                className="mt-2 text-[11px] uppercase tracking-[0.22em] font-medium"
                style={{ color: a.accent }}
              >
                {a.tag}
              </p>
              <p className="mt-5 body-prose text-[14px] leading-relaxed text-ink/75 group-hover:text-ivory/85">
                {a.description}
              </p>
            </article>
          ))}

          {/* Filler card to align grid on last row */}
          <div className="hidden lg:flex bg-ink text-ivory p-8 flex-col justify-between">
            <Gamepad2 size={28} className="text-saffron" />
            <div>
              <p
                className="text-2xl"
                style={{ fontFamily: '"Cormorant Garamond", serif', fontWeight: 500 }}
              >
                Want to bring these into your school?
              </p>
              <a
                href="#contact"
                data-testid="activities-cta"
                className="mt-6 inline-flex items-center gap-2 text-[12px] uppercase tracking-[0.22em] text-saffron hover:text-ivory transition-colors"
              >
                Get in touch
                <ArrowUpRight size={14} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
